import { render, staticRenderFns } from "./CompanyBilling.vue?vue&type=template&id=6e12526b&"
import script from "./CompanyBilling.vue?vue&type=script&lang=js&"
export * from "./CompanyBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports